const { getOffsetTop } = window.BAO.Utils

class FocusFooter extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onKeyUp = this.onKeyUp.bind(this)

    // Listen for tabbing.
    this.listeners.add(document, 'keyup', this.onKeyUp)
  }

  onKeyUp (e) {
    // If tabbing.
    if (e.keyCode !== 9) return

    if (this.hasFooterReceivedFocus()) {
      this.scrollToFooter()
    }
  }

  scrollToFooter () {
    const footerTop = getOffsetTop(this.externalEls.footer.element)

    window.scrollTo({
      top: footerTop,
      behavior: 'smooth',
    })
  }

  // If an element in the fixed bar receives focus, the fixed bar should be visible.
  hasFooterReceivedFocus () {
    if (this.contains(document.activeElement)) {
      return true
    }

    return false
  }
}

if (!customElements.get('focus-footer')) {
  customElements.define('focus-footer', FocusFooter)
}
